import { Toaster } from "react-hot-toast";
import { FaCheck } from "react-icons/fa";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../Common/Header";
import { useNavigate } from "react-router-dom";

const Unlimited = () => {
  const [Subscription, setSubscription] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  // Redirect to dashboard if location.state is null
  useEffect(() => {
    if (!location.state) {
      navigate(-1);
    }
  }, [location.state, navigate]);
  const { selectedPackage } = location.state || {};
  console.log("selectedPackage=>", selectedPackage);
  useEffect(() => {
    localStorage.setItem("UnlimitedChanges", JSON.stringify("unlimited"));
  }, []);
  const handleSavePaymentData = (data) => {
    localStorage.setItem("UnlimitedChanges", JSON.stringify(data));
  };
  const handleContinue = () => {
    const updatedPackage = {
      ...selectedPackage,
      BuySubscription: Subscription,
    };
    console.log("Updated Package:", updatedPackage);
    navigate("/make-will-online/subscription/payment-couple", {
      state: { updatedPackage },
    });
  };
  return (
    <>
      <Toaster />
      <Header />
      <div className="bg-primary w-full h-screen">
        <div className="container">
          <div className="grid grid-cols-2 max-md:grid-cols-1 text-black ">
            <div>
              <div className="bg-[#fff] h-auto p-5">
                <div className="px-5">
                  <p className="font-bold text-[22px] md:text-[26px] sm:text-[22px] lg:text-[28px]">
                    Unlimited updates
                  </p>
                  <p className="text-xs sm:text-sm md:text-base text-slate-500 py-1">
                    As life changes, so should your will.
                  </p>
                  <p className="text-xs sm:text-sm md:text-base text-slate-500 py-1 ">
                    You’ll want to update your will if you start a long-term
                    relationship, get married or divorced, have children,
                    grandchildren, buy a house, or come into assets.
                  </p>
                </div>
                <div className="flex items-start gap-2 border-b-2 border-dashed w-full px-5 mt-4">
                  <input
                    id="post_check0"
                    name="Post-check"
                    type="radio"
                    onChange={() => {
                      setSubscription(1);
                      handleSavePaymentData("unlimited");
                    }}
                    checked={Subscription === 1}
                    className="w-4 h-4 mt-1 text-[#240642] bg-gray-100 border-gray-300 rounded-full   dark:focus:ring-[#240642] dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <div>
                    <div className="flex justify-between flex-wrap w-full">
                      <div className="w-[50%]">
                        <label htmlFor="post_check0">
                          <p className="font-semibold text-sm sm:text-base lg:text-lg">
                            Unlimited changes
                          </p>
                        </label>
                      </div>
                      <div className="w-[50%] flex justify-end">
                        <p className="font-bold text-sm sm:text-base lg:text-lg">
                          A$ {parseInt(selectedPackage?.subscription_price)} a
                          year
                        </p>
                      </div>
                    </div>

                    <div className="pt-5 space-y-2">
                      <p className="flex items-center gap-2 sm:gap-4 font-bold text-sm sm:text-base opacity-70">
                        <FaCheck /> Your first year totally free
                      </p>
                      <p className="flex items-center gap-2 sm:gap-4 font-bold text-sm sm:text-base opacity-70">
                        <FaCheck /> Keep your will up to date
                      </p>
                      <p className="flex items-center gap-2 sm:gap-4 font-bold text-sm sm:text-base opacity-70">
                        <FaCheck /> Chosen by 92% of customers
                      </p>
                    </div>

                    <p className="text-xs sm:text-sm md:text-base text-slate-500 py-3 sm:py-5 mt-2">
                      Your first subscription payment will be on{" "}
                      {new Date(
                        selectedPackage?.nextYearDate
                      ).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                      . You can cancel your subscription at any time from your
                      account.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2 pt-4 px-5">
                  <input
                    id="post_check1"
                    name="Post-check"
                    type="radio"
                    onChange={() => {
                      setSubscription(0);
                      handleSavePaymentData("No");
                    }}
                    checked={Subscription === 0}
                    className="w-4 h-4 mt-1 text-[#240642] bg-gray-100 border-gray-300 rounded-full   dark:focus:ring-[#240642] dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <div className="">
                    <label htmlFor={`post_check1`}>
                      <p className="font-semibold  text-sm sm:text-base lg:text-lg">
                        No thanks, I don’t think I will need to update my will
                      </p>
                    </label>
                    <p className="text-xs sm:text-sm md:text-base text-slate-500 py-1">
                      You can make changes to your will for one year only. After
                      that, you will need to buy the will again at the full
                      price of A${parseInt(selectedPackage?.price)}.
                    </p>
                    <p className="text-xs sm:text-sm md:text-base text-slate-500 py-1">
                      Discount codes cannot be reused.{" "}
                    </p>
                  </div>
                </div>
                <div className="mt-4 px-5">
                  <button
                    className="border-2 w-full rounded-[5px] bg-primary text-white border-[#240642] text-[#240642] px-4 py-3 font-bold"
                    onClick={handleContinue}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
            <div className="max-lg:hidden">
              <div className="fixed bottom-[0px] w-[500px] right-[6%]  flex justify-center">
                <img
                  src="/assets/images/1.png"
                  alt="wills-guru-logo-white"
                  className="h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Unlimited;
